<template>
  <With_Header_Modal_Template title="Аренда рабочего места" width="700px">
    <preload-content :loading="loading || !canConfirm" min-height="335px">
      <div class="content" v-if="!loading && canConfirm">
        <div class="top">
          <h2>Оформление заказа</h2>
          <div class="modal_rent_checkout_carousel_wrap">
            <agile
                ref="agile"
                :infinite="false"
                :slides-to-show="3"
                :dots="false"
                :navButtons="false"
                :swipeDistance="99999"
                @after-change="activeIndex = $event.currentSlide"
                v-if="rents.length > 0"
            >
              <div v-for="(rent, index) in rents" :key="index">
                <preload-content :loading="destroying === index" min-height="138px">
                  <Rent_Checkout_Card
                      :title="rent.title"
                      :desc="rent.desc"
                      :date="rent.date"
                      @delete="destroyRent(index)"
                  />
                </preload-content>

              </div>

              <div class="invisible__rent_checkout_card"></div>
              <div class="invisible__rent_checkout_card"></div>
            </agile>
            <button
                :disabled="activeIndex <= 0"
                @click="prevSlide"
                class="agile__nav-button agile__nav-button--prev"
            ></button>
            <button
                :disabled="activeIndex >= packages.length - 1"
                @click="nextSlide"
                class="agile__nav-button agile__nav-button--next"
            ></button>
          </div>
        </div>
        <div class="payment">
          <div class="left">
            <template v-if="totalSum">
              <h3>Способ оплаты</h3>
              <div class="radio_wrap">
                <custom-radio
                    v-for="type in types" :key="type.type"
                    :text="type.checkbox"
                    name="payment_type"
                    :checked="type.type === selectedType"
                    :disabled="!canConfirm"
                    @change="selectedType = type.type"
                />
              </div>
            </template>
          </div>
          <div class="right">
            <div class="payment_item">
              <div>
                <div class="desc">Общая сумма</div>
                <div class="desc" v-if="totalHours">(за {{ totalHours }} часа)</div>
              </div>
              <div class="price">{{ totalPrice }} <span>Р</span></div>
            </div>
            <div class="payment_item" v-if="totalPackage.bonusHours">
              <div>
                <div class="desc">Списание с бонусных часов</div>
                <div class="desc">({{ totalPackage.bonusHours }} часов)</div>
              </div>
              <div class="price">-{{ totalPackage.bonusSum }} <span>Р</span></div>
            </div>
            <div class="payment_item" v-if="totalPackage.hours">
              <div>
                <div class="desc">Списание с пакета часов</div>
                <div class="desc">(<strong>{{ totalPackage.hours }}</strong> часов)</div>
              </div>
              <div class="price">-{{ totalPackage.sum }} <span>Р</span></div>
            </div>
            <div class="payment_item" v-if="showBonusBlock">
              <div>
                <custom-checkbox
                    id="withPortfolio"
                    v-model="bonusPaid"
                >
                  <div class="desc">Использовать бонусные баллы</div>
                </custom-checkbox>
                <div class="desc">({{ totalPoints }} баллов)</div>
              </div>
              <div class="price" v-if="bonusAttr">-{{ bonusAttr }} <span>Р</span></div>
            </div>
            <div class="total">
              <span>Итого</span>
              <div class="total_price">{{ totalSum }} Р</div>
            </div>
          </div>
        </div>
      </div>
    </preload-content>
    <div slot="footer">
      <div v-if="!totalSum">
        <button @click="confirm()" :disabled="!canConfirm">Подтвердить</button>
      </div>
      <div v-else v-for="type in types" :key="type.type">
        <button v-if="type.type === selectedType" @click="confirm()" :disabled="!canConfirm">{{ type.btn }}</button>
      </div>
    </div>
  </With_Header_Modal_Template>
</template>

<script>
import CustomCheckbox from '@/components/ui/inputs/custom-checkbox'
import PreloadContent from '@/components/ui/preload-content'
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'
import CustomRadio from '@/components/ui/inputs/custom-radio'
import Rent_Checkout_Card from '@/components/Modals/ModalsComponents/Rent_Checkout_Card'
import {mapGetters, mapMutations} from 'vuex'
import moment from "moment"

export default {
  name: "Rent_Checkout",
  components: {Rent_Checkout_Card, CustomRadio, With_Header_Modal_Template, PreloadContent, CustomCheckbox},
  data() {
    return {
      bonusPaid: true,

      activeIndex: 0,

      confirming: false,
      destroying: null,

      packages: null,
      selectedType: 'coworking',
      types: [
        {btn: 'Оплатить онлайн', type: 'card', checkbox: 'Онлайн-оплата картой'},
        {btn: 'Оформить заказ', type: 'coworking', checkbox: 'Оплата в коворкинге'}
      ],

      hours: null,
      bonus: null,
    }
  },
  watch: {
    canConfirm(to) {
      if (!to) this.selectedType = 'coworking'
    },
  },
  computed: {
    ...mapGetters(['modal_data', 'getUser']),
    loading() {
      return !this.modal_data || !this.rents || !this.packages || this.bonus === null;
    },
    canConfirm() {
      return this.modal_data && this.modal_data.data.length && !this.confirming
    },
    rents() {
      if (!this.modal_data) return 0;
      return this.modal_data.data.map((val) => {
        return {
          id: val.id,
          title: val.zone.name + this.getTitleWorkplaces(val.workplaces),
          date: this.getRentDate(val),
          desc: val.coworking.name
        }
      })
    },
    totalHours() {
      if (!this.modal_data) return 0
      return this.modal_data.data.map((val) => {
        return moment(val.end, 'YYYY-MM-DD HH:mm:ss').diff(moment(val.start, 'YYYY-MM-DD HH:mm:ss'), 'minutes') / 60
      }).reduce((accumulator, currentValue) => accumulator + currentValue)
    },
    totalPrice() {
      if (!this.totalHours) return 0
      return this.modal_data.data.map((val) => val.zone.price * val.workplaces.length)
              .reduce((accumulator, currentValue) => accumulator + currentValue)
          * this.totalHours
    },
    showBonusBlock() {
      return this.selectedType === "card" && this.totalPoints;
    },
    bonusAttr() {
      return this.selectedType === "card" && this.bonusPaid ? this.totalPoints : 0;
    },
    totalPoints() {
      if (this.loading) return 0;
      let packageSum = this.totalPackage.sum + this.totalPackage.bonusSum;
      let restSum = this.totalPrice - packageSum;
      if (restSum <= 0) return 0;
      return restSum > this.bonus ? this.bonus : this.bonus - restSum;
    },
    totalPackage() {
      let restBonusHours = this.hours;
      let pack = {hours: 0, sum: 0, bonusHours: 0, bonusSum: 0};
      if (!this.modal_data || !this.packages) return pack
      this.modal_data.data.forEach((val) => {
        let rentHours = this.getRentHoursByZone(val.zone.id) * val.workplaces.length;

        console.log(rentHours);
        if (restBonusHours) {
          let payHours = rentHours > restBonusHours ? restBonusHours : rentHours;

          pack.bonusHours = pack.bonusHours + payHours;
          pack.bonusSum = pack.bonusSum + (payHours * val.zone.price);

          restBonusHours = restBonusHours - payHours;
          rentHours = rentHours - payHours;
        }
        let tariffHours = this.getTariffHoursByZone(val.zone.id);
        let hours = tariffHours > rentHours ? rentHours : tariffHours;

        pack.hours = pack.hours + hours;
        pack.sum = ((hours * val.zone.price) * val.workplaces.length) + pack.sum;
      });
      return pack;
    },
    totalSum() {
      return this.totalPrice - this.totalPackage.sum - this.totalPackage.bonusSum - this.bonusAttr
    }
  },
  mounted() {
    this.loadBonus();
    return this.$api.master.package.active({
      coworking_id: this.modal_data.data[0].coworking_id,
      zones: this.modal_data.data.map(val => val.zone.id).filter((val, index, self) => self.indexOf(val) === index)
    }).then(({data}) => this.packages = data)
  },
  methods: {
    ...mapMutations(['closeModals', 'setUser']),
    loadBonus() {
      let rents = [];
      this.rents.forEach(val => rents.push(val.id));
      this.$api.bonus.rent({rents: rents}).then((data) => {
        this.hours = data.hours;
        this.bonus = data.bonus;
      });
    },
    confirm() {
      this.confirming = true
      this.$api.payment.rent.create({
        pay_type: this.selectedType,
        rents: this.rents.map(val => val.id),
        bonus: this.bonusPaid
      }).then(({data}) => {
        if (data.redirect_url) {
          this.$toast.success('Перенаправляем на страницу оплаты')
          return setTimeout(() => window.location.href = data.redirect_url, 1000)
        }
        if (data.user) this.setUser(data.user)
        this.$toast.success('Аренда успешно подтверждена!');
        if (this.modal_data.redirect) this.$router.push(this.modal_data.redirect)
        this.closeModals()
      }).catch(({response}) => {
        if (response.data.exception) this.$toast.error(response.data.message)
        if (response.data.errors) this.$toast.error(response.data.errors[Object.keys(response.data.errors)[0]][0])
      }).finally(() => this.confirming = false)
    },
    destroyRent(index) {
      this.destroying = index
      this.$api.master.rent.destroy(this.rents[index].id).then(() => {
        this.modal_data.data.splice(index, 1)
        this.$refs.agile.reload()
        if (this.modal_data.data.length) return
        this.$toast.error('Процесс аренды коворкинга отменен!')
        this.closeModals()
      }).finally(() => this.destroying = false)
    },
    getTariffHoursByZone(zone) {
      let pack = this.packages.filter(val => val.zone_id === zone)
      if (!pack.length) return 0
      return pack.map(val => val.last_hours)
          .reduce((sum, val) => sum + val)
    },
    getRentHoursByZone(zone) {
      return this.modal_data.data.filter((val) => val.zone.id === zone)
          .map((val) => moment(val.end, 'YYYY-MM-DD HH:mm:ss').diff(moment(val.start, 'YYYY-MM-DD HH:mm:ss'), 'minutes') / 60)
          .reduce((accumulator, currentValue) => accumulator + currentValue)
    },
    getTitleWorkplaces(workplaces) {
      if (!workplaces) return
      if (workplaces.length === 1) return `, место ${workplaces[0].number}`
      return ', места: ' + workplaces.map(val => val.number).join(',')
    },
    getRentDate(rent) {
      if (!rent.start || !rent.end) return null
      return moment(rent.start, 'YYYY-MM-DD HH:mm:ss').locale('ru').format('ddd, DD MMMM, HH:ss-')
          + moment(rent.end, 'YYYY-MM-DD HH:mm:ss').format('HH:ss')
    },

    prevSlide() {
      if (this.$refs.agile.getCurrentSlide() > 0) {
        this.$refs.agile.goToPrev()
      }
    },
    nextSlide() {
      if (this.$refs.agile.getCurrentSlide() < this.periods.length - 1) {
        this.$refs.agile.goToNext()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.modal_rent_checkout_carousel_wrap {
  position: relative;
  z-index: 2;
  margin: -10px;
  width: 850px;

  &:after {
    content: '';
    position: absolute;
    z-index: 1;
    top: 0;
    bottom: 0;
    right: 160px;
    width: 110px;
    background-image: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
  }

  .agile__nav-button {
    font-size: 0;
    width: 40px;
    height: 40px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(0, 0, 0, 0.04), 0 0 1px rgba(0, 0, 0, 0.04);
    position: absolute;
    z-index: 2;
    top: 50%;
    transform: translateY(-50%);
    transition: 150ms opacity ease;
    opacity: 1;
    background-color: #FFFFFF;
    border: 1px solid #B9765B;
    border-radius: 5px;
    background-position: center center;
    background-repeat: no-repeat;

    &:hover {
      filter: brightness(94%);
    }

    &:disabled {
      opacity: 0;
    }

    &--prev {
      left: 0;
      background-image: url('../../../assets/images/icons/chevron-left.svg');
    }

    &--next {
      right: 190px;
      background-image: url('../../../assets/images/icons/chevron-right.svg');
    }
  }
}

.invisible__rent_checkout_card {
  width: 270px;
}

h2 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.33;
  color: #383838;
  margin-bottom: 30px;
}

h3 {
  margin-bottom: 20px;
}

.content {
  overflow: hidden;
  padding: 30px;
}

.payment {
  display: flex;
  padding-top: 30px;

  .left {
    width: 37%;
    padding-right: 30px;

    .radio_wrap {
      margin-bottom: 10px;
    }
  }

  .right {
    width: 63%;
    padding-left: 30px;
    border-left: 1px solid #E5E5E5;
  }

  &_item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;

    .desc {
      font-family: "Open Sans", sans-serif;
      font-size: 16px;
      line-height: 1.5;
      color: #383838;
    }

    .price {
      font-family: "Open Sans", sans-serif;
      font-weight: 600;
      font-size: 20px;
      line-height: 1.4;
      color: #383838;

      span {
        font-size: 16px;
      }
    }
  }

  .total {
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-family: "Open Sans", sans-serif;
      font-weight: 600;
      font-size: 16px;
      line-height: 1.5;
      color: #383838;
    }

    .total_price {
      font-family: "Montserrat", sans-serif;
      font-weight: 600;
      font-size: 32px;
      line-height: 125%;
      color: #383838;
    }
  }
}

@media (max-width: 426px) {
  .payment {
    flex-wrap: wrap;
  }

  .payment > .left {
    border-bottom: 1px solid #E5E5E5;
    margin-bottom: 20px;
  }
  .payment > .left, .payment > .right {
    width: 100%;
    padding-left: unset;
    border-left: unset;
  }
}
</style>
